import React from 'react';
import { Link, IndexLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Moment from 'react-moment';
import Pagination from "react-js-pagination";
import * as constant from '../../constants/constant';
import * as MarketingActions from '../../actions/marketingActions';
import 'react-toastify/dist/ReactToastify.css';
import autoBind from 'auto-bind';
import validator from './../common/validator.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Reaptcha from 'reaptcha';
import {Button, Form, FormGroup, Label, Input, Alert} from 'react-bootstrap';

// {constant.PRODUCTION_IMAGE_URL + 'patientImage/' + image}
const size = 10;
let btnSize = { fontSize: '13' };
class SpecialistSupport extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
			pageContent: [],
			activePage: 1,
			count: 10,

			name: { value: "", message: "", isValid: true },
			email: { value: "", message: "", isValid: true },
			msg: { value: "", message: "", isValid: true },
			recaptchaVerified: false,
			recaptchaError : false,
		};
        // this.onLogoutclick = this.onLogoutclick.bind(this);
        this._logout = this._logout.bind(this);
        // this.handleClick = this.handleClick.bind(this);
        // this.handleOutsideClick = this.handleOutsideClick.bind(this);

    }

    _logout(event) {
        let userId = localStorage.getItem('userId')
        this.props.actions.logout({ 'userId': userId })
        event.preventDefault();
        localStorage.clear();
        this.props.history.push('/');
    }



    render() {
        var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2')
        if (user.image == constant.DEFAULT_USER_IMAGE) {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.tempImage;
		}
		var userType = localStorage.getItem('userType');
        return (
            <div>
                	<header className="main-header">
					<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
                <div className="content-wrapper">
					<section className="content container-fluid">
						<ToastContainer  position="bottom-left" rtl={true}/>
						<div className="row">
							<div className="col-md-12">
                            <Fragment>
            <h1>Create a new ticket</h1>
            {this.state.error && <Alert color="danger">
                Please make sure to fill all fields correctly
            </Alert>}
            <Form onSubmit={this.handleSubmit}>
                <FormGroup>
                    <label for="ticketTitle">Title</label>
                    <input type="text" name="title" id="ticketTitle" placeholder="Ticket Title"
                           value={this.state.formData.title}
                           onChange={this.handleChange}/>
                </FormGroup>
                <FormGroup>
                    <label for="ticketBody">Body</label>
                    <input type="textarea" name="body" id="ticketBody" value={this.state.formData.body}
                           onChange={this.handleChange}/>
                </FormGroup>
                {/* <Query query={getTicketTypes}>
                    {({loading, error, data}) => {
                        if (loading) return <p>Loading ticket types</p>;
                        if (error) return <p>Error loading ticket types</p>;
                        return <RenderTypes handleChange={this.handleChange} val={this.state.formData.type}
                                            types={data.types.values}/>
                    }}
                </Query> */}
                <Button>Submit</Button>
            </Form>

        </Fragment>
                </div>
                </div>
                </section>
                </div>
            </div>
        );
    }
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
    return {
        // specialistPatients: state.specialist.specialistPatients
    };
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistSupport);